<template>
    <b-dropdown
        :class="{ 'disabled': disabled, 'highlighted': highlight }"
        :split-href="url"
        :toggle-class="{ 'd-none': disabled }"
        toggle-text="Ouvrir le menu"
        toggle-tag="aca-breadcrumb-dropdown-toggle"
        :menu-class="['w-100 border-0 mt-0 pb-5', { 'd-none': menuHidden }]"
        no-flip
        split-class="btn-split"
        split
        variant="indigo"
        v-bind="$attrs"
        @show="handleOpened"
        @click="handleClicked"
        ref="dropdown"
    >
        <template v-slot:button-content>
            <slot />
        </template>
        <template v-if="loaded">
            <template v-for="page in filteredPages">
                <b-dropdown-item :href="page.uri" :key="page.id" :data-theme="page.theme">
                    <div class="dropdown-item-inner">
                        {{ page.menu_title }}
                    </div>
                </b-dropdown-item>
            </template>
        </template>
        <template v-else>
            <b-dropdown-text class="text-center">
                <div class="spinner-grow spinner-grow-sm"></div>
            </b-dropdown-text>
        </template>
    </b-dropdown>
</template>

<script>
    import { BDropdown, BDropdownItem, BDropdownText } from 'bootstrap-vue';
    import { getBreadcrumbPages } from "../api";

    export default {
        components: {
            BDropdown,
            BDropdownItem,
            BDropdownText,
        },
        props: {
            url: String,
            pageId: String,
            disabled: Boolean,
            highlight: Boolean,
        },
        data() {
            return {
                pages: null,
                loaded: false,
            }
        },
        computed: {
            filteredPages() {
                return (this.pages ?? []).filter(page => page.id !== this.pageId);
            },
            menuHidden() {
                return this.loaded && !this.filteredPages.length;
            },
        },
        methods: {
            async handleOpened() {
                if(!this.pages) {
                    this.pages = await getBreadcrumbPages(this.pageId);
                    this.loaded = true;
                }
            },
            handleClicked(e) {
                if(this.disabled) {
                    return;
                }
                if(this.active) {
                    e.preventDefault();
                    this.$refs.dropdown.show();
                }
            }
        }
    }
</script>
